import { render, staticRenderFns } from "./DemoSearch.vue?vue&type=template&id=72cd6e92&scoped=true&"
import script from "./DemoSearch.vue?vue&type=script&lang=js&"
export * from "./DemoSearch.vue?vue&type=script&lang=js&"
import style0 from "./DemoSearch.vue?vue&type=style&index=0&id=72cd6e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd6e92",
  null
  
)

export default component.exports